
import getters from './graph/getters'

export default getters
